import { render } from "./GoodsInventoryList.vue?vue&type=template&id=9fe16102"
import script from "./GoodsInventoryList.vue?vue&type=script&lang=js"
export * from "./GoodsInventoryList.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__